import { render, staticRenderFns } from "./pid-switch-unit.vue?vue&type=template&id=10557658&scoped=true"
import script from "./pid-switch-unit.vue?vue&type=script&lang=js"
export * from "./pid-switch-unit.vue?vue&type=script&lang=js"
import style0 from "./pid-switch-unit.vue?vue&type=style&index=0&id=10557658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10557658",
  null
  
)

export default component.exports